import { render, staticRenderFns } from "./ResourceNotFound.vue?vue&type=template&id=03c171ce&scoped=true&"
import script from "./ResourceNotFound.vue?vue&type=script&lang=js&"
export * from "./ResourceNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c171ce",
  null
  
)

export default component.exports